import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Rise } from "../components/Reveal";
import { COPY } from "../content/copy";
import { ImageTrigger } from "../components/viewer/ImageTrigger";
import { BOTTEGA_IMAGES } from "../components/viewer/galleries";

export default function Bottega() {
    const clipRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: clipRef,
        offset: ["start end", "end start"],
    });
    const y = useTransform(scrollYProgress, [0, 1], [-18, 18]);
    const b = COPY.bottega;

    return (
        <section className="section" data-testid="bottega-block">
            <div className="container">
                <Rise>
                    <p className="caption">{b.caption}</p>
                </Rise>
                <Rise className="bottega-figure-wrap">
                    <div className="bottega-frame-clip" ref={clipRef}>
                        <motion.figure
                            className="bottega-frame"
                            style={{ y }}
                            data-testid="bottega-figure"
                        >
                            <ImageTrigger images={BOTTEGA_IMAGES} index={0} className="image-trigger--desktop" testId="bottega-desktop-open">
                            <img
                                className="bottega-shot"
                                src={b.images.desktop}
                                alt="La home di Bottega Paesano su desktop"
                                loading="lazy"
                                data-testid="bottega-image-desktop"
                            />
                            </ImageTrigger>
                            <ImageTrigger images={BOTTEGA_IMAGES} index={1} className="image-trigger--phone" testId="bottega-mobile-open">
                            <img
                                className="bottega-phone"
                                src={b.images.mobile}
                                alt="La home di Bottega Paesano su telefono"
                                loading="lazy"
                                data-testid="bottega-image-mobile"
                            />
                            </ImageTrigger>
                        </motion.figure>
                    </div>
                </Rise>
                <Rise>
                    <h2 className="h2 bottega-name">{b.name}</h2>
                </Rise>
                <Rise delay={0.05}>
                    <p className="caption bottega-did" data-testid="bottega-did">
                        {b.did.join(" · ")}
                    </p>
                </Rise>
                <Rise delay={0.08}>
                    <p className="body bottega-text">{b.text}</p>
                </Rise>
                <Rise delay={0.1}>
                    <p className="ital bottega-number" data-testid="bottega-number">{b.number}</p>
                </Rise>
                {b.backstage && (
                    <div className="bottega-backstage" data-testid="bottega-backstage">
                        <Rise className="backstage-photo">
                            <figure>
                                <ImageTrigger images={BOTTEGA_IMAGES} index={2} testId="bottega-backstage-open">
                                    <img src={b.backstage.src} alt={b.backstage.alt} loading="lazy" />
                                </ImageTrigger>
                            </figure>
                        </Rise>
                        <Rise delay={0.1} className="backstage-text">
                            <p className="caption">{b.backstage.caption}</p>
                            <p className="body">{b.backstage.text}</p>
                        </Rise>
                    </div>
                )}
                <div className="bottega-app" data-testid="bottega-app">
                    <Rise>
                        <p className="caption">{b.app.caption}</p>
                    </Rise>
                    <div className="app-screens">
                        {b.app.screens.map((s, i) => (
                            <Rise key={s.src} delay={i * 0.12} className={`app-screen app-screen-${i}`}>
                                <figure>
                                    <ImageTrigger images={BOTTEGA_IMAGES} index={i + 3} testId={`bottega-app-open-${i}`}>
                                        <img src={s.src} alt={s.label} loading="lazy" data-testid={`bottega-app-screen-${i}`} />
                                    </ImageTrigger>
                                    <figcaption className="caption">{s.label}</figcaption>
                                </figure>
                            </Rise>
                        ))}
                    </div>
                    <Rise>
                        <p className="body bottega-app-text" data-testid="bottega-app-text">{b.app.text}</p>
                    </Rise>
                </div>
                <Rise delay={0.15}>
                    <div className="bottega-links">
                        <a
                            className="tlink"
                            href={b.link.href}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="bottega-store-link"
                        >
                            {b.link.label}
                        </a>
                    </div>
                    <p className="caption bottega-note">{b.note}</p>
                </Rise>
            </div>
        </section>
    );
}
